import { SURFACE, WEEKDAY_COLORS_BY_JS_DAY } from "../common/designTokens";

/**
 * Pivot palette — the shared neutral surface (`SURFACE`) plus the semantic value colors the
 * pivot tables need.
 *
 * Those value colors are pivot-local on purpose. The app theme's success/warning/error are
 * tuned for chips and buttons on colored surfaces; the pivot tables render 12–13.5px numbers
 * on white and need darker tones (plus matching pale tints behind the badges) to clear 4.5:1.
 */
export const PV = {
  indigo: SURFACE.accent,
  indigoDark: SURFACE.accentDark,
  indigoTint: SURFACE.accentTint,
  indigoBorder: SURFACE.accentBorder,

  /** ขาย — sell-through, the healthy direction. */
  sell: "#1E8C4E",
  sellTint: "#E7F6EE",
  /** เหลือ — stock parked at the customer; watch, not alarm. */
  leftover: "#B57210",
  leftoverTint: "#FEF3E2",
  /** ของเสีย — absorbed cost. Also the alarm tone for stale visits. */
  waste: "#C93639",
  wasteTint: "#FDECEC",

  card: SURFACE.card,
  head: SURFACE.head,
  rowHover: SURFACE.hover,
  line: SURFACE.line,
  line2: SURFACE.line2,

  tx: SURFACE.tx,
  tx2: SURFACE.tx2,
  tx3: SURFACE.tx3,

  radius: SURFACE.radius,
  radiusSm: SURFACE.radiusSm,
  shadow: SURFACE.shadow,
} as const;

/** Re-exported under the pivot's own name; the visit calendar keys cells by `dayjs().day()`. */
export const WEEKDAY_COLORS = WEEKDAY_COLORS_BY_JS_DAY;

/** Card surface shared by every pivot panel (segs bar, filter bar, overview, table). */
export const cardSx = {
  bgcolor: PV.card,
  border: "1px solid",
  borderColor: PV.line2,
  borderRadius: PV.radius,
  boxShadow: PV.shadow,
} as const;
